<div mat-dialog-title>
  {{'Emergency contacts'| translate}}
  <span class="float-right pointer" (click)="close()">
    <i class="fa fa-times close-btn "></i>
  </span>
  <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->


</div>
<div mat-dialog-content class="">

  <form [formGroup]="nomForm">
    <div class="row">
      <div class="col-md-3" *ngIf="field_config_access && field_config_access['RES-emg_relationTypeId']">
        <tm-select [options]="master_data.relationList||[]" [form_group]="nomForm" form_control="relationTypeId"
          title_property="title"
          [label]=" field_config_access['RES-emg_relationTypeId'].label ||'Relation type' | translate" id_property="id"
          float_label="always" [data]="nomForm.value.relationTypeId"
          [placeholder]=" field_config_access['RES-emg_relationTypeId'].placeholder ||'<- -Select- ->' | translate">
        </tm-select>
      </div>
      <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-emg_name']">
        <mat-form-field floatLabel='always'>
          <mat-label> {{field_config_access['RES-emg_name'].label ||'Name'}}
          </mat-label>
          <input matInput formControlName="name"
            [placeholder]="field_config_access['RES-emg_name'].placeholder ||'Name'">
          <mat-error *ngIf="nomForm.controls.name.touched &&  nomForm.controls.name.hasError('required')">
            {{'ERROR.field_is_mandatory'|translate}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6" *ngIf="field_config_access && field_config_access['RES-emg_mobileIsd']">
        <div class="prefix-control" style="width: 35%;">
          <tm-select [options]="country_list||[]" [form_group]="nomForm" form_control="mobileIsd" title_property="name"
            id_property="dial_code" float_label="always"
            [label]="field_config_access['RES-emg_mobileIsd'].label||'Mobile number'|translate"
            [data]="nomForm.value.mobileIsd" [label_overflow]="1" (selected_obj)="countryCodeChanges($event)"
            [placeholder]="field_config_access['RES-emg_mobileIsd'].placeholder||'< - - Select - - >' | translate">
          </tm-select>
        </div>
        <div class="main-control" style="width: 65%;"
          *ngIf="field_config_access && field_config_access['RES-emg_mobileNumber']">
          <!-- <app-phone-number
                [placeholder]="field_config_access['RES-emg_mobileNumber'].placeholder||'Enter mobile number'|translate"
                [form]="nomForm"  controlName="mobileNumber"
                [label]="field_config_access['RES-emg_mobileNumber'].label||'Mobile number'|translate"
                [hide_label]="1" [data]="this.nomForm.controls['mobileNumber'].value" [maxLength]="maxLength"
                [minLength]="minLength" [pattern_desc]="'^[0-9]*$'">
              </app-phone-number> -->
          <app-phone-number
            [placeholder]="field_config_access['RES-emg_mobileNumber'].placeholder ||'Enter mobile number'|translate"
            [form]="nomForm" controlName="mobileNumber" [data]="this.nomForm.controls['mobileNumber'].value"
            [maxLength]="this.registration.mobile_number_length" [disabledDial]="1"
            [minLength]="this.registration.mobile_number_length ||0" [pattern_desc]="'^[0-9]*$'" [required]="1"
            [hide_label]="1">
          </app-phone-number>
        </div>
      </div>
      <div class="col-md-6" *ngIf="field_config_access && field_config_access['RES-emg_phoneIsd']">
        <div class="prefix-control" style="width: 35%;">
          <tm-select [options]="country_list||[]" [form_group]="nomForm" form_control="phoneIsd" title_property="name"
            id_property="dial_code" float_label="always"
            [label]="field_config_access['RES-emg_phoneIsd'].label||'Phone number'|translate"
            [data]="nomForm.value.phoneIsd" [label_overflow]="1"
            [placeholder]="field_config_access['RES-emg_phoneIsd'].placeholder||'< - - Select - - >' | translate">
          </tm-select>
        </div>
        <div class="main-control" style="width: 65%;"
          *ngIf="field_config_access && field_config_access['RES-emg_phoneNumber']">
          <!-- <app-phone-number
                [placeholder]="field_config_access['RES-emg_phoneNumber'].placeholder||'Enter phone number'|translate"
                [form]="nomForm"  controlName="phoneNumber"
                [label]="field_config_access['RES-emg_phoneNumber'].label||'Phone number'|translate"
                [hide_label]="1" [data]="this.nomForm.controls['phoneNumber'].value" [maxLength]="maxLength"
                [minLength]="minLength" [pattern_desc]="'^[0-9]*$'">
              </app-phone-number> -->
          <app-phone-number
            [placeholder]="field_config_access['RES-emg_phoneNumber'].placeholder ||'Enter mobile number'|translate"
            [form]="nomForm" controlName="phoneNumber" [data]="this.nomForm.controls['phoneNumber'].value"
            [maxLength]="this.registration.mobile_number_length" [disabledDial]="1"
            [minLength]="this.registration.mobile_number_length ||0" [pattern_desc]="'^[0-9]*$'" [required]="1"
            [hide_label]="1">
          </app-phone-number>
        </div>
      </div>
      <!-- <div class="col-md-3" *ngIf="field_config_access && field_config_access['RES-emg_dob']">
          <tm-date-picker [form]="nomForm" [controlName]="'dob'" [maxValue]="date"
            [label]=" field_config_access['RES-emg_dob'].label || 'Date of birth' " [value]="nomForm.value.dob"
            [placeholder]=" field_config_access['RES-emg_dob'].placeholder || 'Select date' "> </tm-date-picker>
        </div> -->

      <div class="col-md-3" *ngIf=" field_config_access &&field_config_access['RES-emg_age']">
        <mat-form-field floatLabel='always'>
          <mat-label> {{field_config_access['RES-emg_age'].label ||'Age'}}
          </mat-label>
          <input matInput type="number" formControlName="age"
            [placeholder]="field_config_access['RES-emg_age'].placeholder ||'Age'">
          <mat-error *ngIf="nomForm.controls.age.touched &&  nomForm.controls.age.hasError('required')">
            {{'ERROR.field_is_mandatory'|translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-3" *ngIf="field_config_access && field_config_access['RES-emg_bloodGroup']">
        <tm-select [options]="master_data.bloodGroupList||[]" [form_group]="nomForm" form_control="bloodGroup"
          title_property="title" [label]=" field_config_access['RES-emg_bloodGroup'].label ||'Blood group' | translate"
          id_property="id" float_label="always" [data]="nomForm.value.bloodGroup"
          [placeholder]=" field_config_access['RES-emg_bloodGroup'].placeholder ||'<- -Select- ->' | translate">
        </tm-select>
      </div>

      <div class="col-md-2" *ngIf=" field_config_access &&field_config_access['RES-emg_percentageShare']">
        <mat-form-field floatLabel='always'>
          <mat-label> {{field_config_access['RES-emg_percentageShare'].label ||'Share'}}
          </mat-label>
          <input matInput type="number" formControlName="percentageShare"
            [placeholder]="field_config_access['RES-emg_percentageShare'].placeholder ||'Enter share'">
          <span matSuffix class="tm-suffix">%</span>
          <mat-error
            *ngIf="nomForm.controls.percentageShare.touched &&  nomForm.controls.percentageShare.hasError('required')">
            {{'ERROR.field_is_mandatory'|translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6" *ngIf=" field_config_access &&field_config_access['RES-emg_address']">
        <mat-form-field floatLabel="always">
          <mat-label>{{field_config_access['RES-emg_address'].label ||'Address'}}</mat-label>
          <input matInput formControlName="address"
            [placeholder]="field_config_access['RES-emg_address'].placeholder||'Enter address'|translate">
          <mat-error *ngIf="nomForm.controls.address.touched &&  nomForm.controls.address.hasError('required')">
            {{'ERROR.field_is_mandatory'|translate}}
          </mat-error>
        </mat-form-field>
      </div>


      <div class="col-md-12 text-right ">
        <button (click)="addExperience()" class="btn btn-sm mat-mt js-btn-save">
          <i class="fa fa-plus-square mx-1"></i>
          {{'BTN.add'|translate}}
        </button>
      </div>

      <div class="col-md-12 table-responsive tm-data-table  " style="height: calc(100vh - 400px);overflow: auto;">
        <table class="table table-striped" *ngIf="field_config_access">
          <thead>
            <tr>
              <th *ngIf="field_config_access['RES-emg_relationTypeId']">
                {{
                field_config_access['RES-emg_relationTypeId'].label ||'Relation type'}}
              </th>
              <th *ngIf="field_config_access['RES-emg_name']">
                {{
                field_config_access['RES-emg_name'].label ||'Name' | translate}}
              </th>
              <th *ngIf="field_config_access['RES-emg_mobileNumber']">
                {{field_config_access['RES-emg_mobileNumber'].label ||'Mobile number'}}
              </th>
              <th *ngIf="field_config_access['RES-emg_phoneNumber']">
                {{field_config_access['RES-emg_phoneNumber'].label ||'Phone number'}}
              </th>
              <th class="text-right" *ngIf=" field_config_access['RES-emg_age']">
                {{
                field_config_access['RES-emg_age'].label ||'Age'}}
              </th>
              <th *ngIf="field_config_access['RES-emg_bloodGroup']">
                {{
                field_config_access['RES-emg_bloodGroup'].label ||'Blood group' |translate}}
              </th>
              <th class="text-right" *ngIf="field_config_access['RES-emg_percentageShare']">
                {{
                field_config_access['RES-emg_percentageShare'].label || 'Share' |translate}}
              </th>
              <th *ngIf="field_config_access['RES-emg_address']">
                {{
                field_config_access['RES-emg_address'].label ||'Address'|translate}}
              </th>

              <th class="text-center">
                Action
              </th>
            </tr>

          </thead>
          <tbody>
            <tr *ngFor="let item of exp_list;let i = index">
              <td *ngIf="field_config_access['RES-emg_relationTypeId']"> {{item.relationTypeId |DynamicPipe
                :master_data.relationList :'id' : 'title' }} </td>

              <td *ngIf="field_config_access['RES-emg_name']"> {{ item.name }} </td>
              <td *ngIf="field_config_access['RES-emg_mobileNumber']"> {{item.mobileNumber}} </td>
              <td *ngIf="field_config_access['RES-emg_phoneNumber']"> {{item.phoneNumber}} </td>

              <td *ngIf=" field_config_access['RES-emg_age']" class="text-right"> {{item.age}} </td>
              <td *ngIf="field_config_access['RES-emg_bloodGroup']">
                {{item.bloodGroup | DynamicPipe: master_data['bloodGroupList']:'id':'title'}}
              </td>
              <td class="text-right" *ngIf="field_config_access['RES-emg_percentageShare']">
                {{item.percentageShare}} %
              </td>
              <td *ngIf="field_config_access['RES-emg_address']">
                {{item.address}}
              </td>
              <td class="text-center">
                <button class="btn btn-sm btn-default mx-1 " (click)="editExperience(i)">
                  <i class="fa fa-pencil mx-1"></i>
                  {{'BTN.edit'|translate}}
                </button>
                <button class="btn btn-sm btn-default mx-1 " (click)="deleteExperience(i)">
                  <i class="fa fa-trash orange mx-1"></i>
                  {{'BTN.delete'|translate}}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</div>
<mat-dialog-actions>
  <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

  <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn mx-1 mx-1 tallite-action" (click)="close()">
    {{ 'BTN.cancel' | translate}}
    <span class="blob-btn-cancel__inner">
      <span class="blob-btn-cancel__blobs">
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
      </span>
    </span>
  </button>
  <button style="min-width: 100px;" class="blob-btn  btn   mx-1 tallite-action" type="submit" (click)="save()">
    {{ 'BTN.ok' | translate }}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>
</mat-dialog-actions>